import { Box, styled } from '@mui/material';

import type { ViewContainerProps } from './ViewContainer.types';

export const ViewContainer = ({ children }: ViewContainerProps) => (
  <Container>{children}</Container>
);

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(5, 6, 8),
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(5, 8),
  },
}));
